export default {
  buildTime: '2026-08-26T13:19:55Z',
  commit: 'c5f7ab8c8f529a4a0f509096923fb7e28d2706e9',
  npmInfo: {
    'mashlib': '2.3.3',
    'npm': '11.19.0',
    'node': '22.23.2',
    'acorn': '8.16.0',
    'ada': '2.9.2',
    'amaro': '1.1.8',
    'ares': '1.34.6',
    'brotli': '1.1.0',
    'cjs_module_lexer': '2.2.0',
    'cldr': '48.0',
    'icu': '78.2',
    'llhttp': '9.4.3',
    'modules': '127',
    'napi': '10',
    'nbytes': '0.1.3',
    'ncrypto': '0.0.1',
    'nghttp2': '1.69.0',
    'openssl': '3.5.7',
    'simdjson': '4.5.0',
    'simdutf': '6.4.2',
    'sqlite': '3.51.3',
    'tz': '2026a',
    'undici': '6.28.0',
    'unicode': '17.0',
    'uv': '1.51.0',
    'uvwasi': '0.0.23',
    'v8': '12.4.254.21-node.56',
    'zlib': '1.3.1-e00f703',
    'zstd': '1.5.7',
  }
}
